import { Injectable } from '@angular/core';
import { Location } from "@angular/common";
import { HttpBaseService } from "./http-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MessagingService } from "@otimo/messaging";
import { Observable, throwError, of } from "rxjs";
import { map, catchError } from "rxjs/operators"

import { LoggingService } from "./logging.service";
import { SharedReport } from '../models/shared-report';


@Injectable({ providedIn: 'root' })
export class SharedReportsService extends HttpBaseService {

    constructor(protected override http: HttpClient,
        private location: Location,
        protected override messaging: MessagingService,
        protected override logging: LoggingService
    ) {
        super(http, messaging, logging);
        this.baseUrl = this.location.prepareExternalUrl("/api/sharedReports/");
    }

    public baseUrl: string;

    getFilterSettings(id: string): Observable<any> {
        try {
            return this.http.get(this.baseUrl + "GetFilterSettings/" + id)
                .pipe(map((response: any) => {
                    if (response["result"]) {
                        return JSON.parse(response["result"].serializedFilterSettings)
                    } else if (response["Result"]) {
                        return JSON.parse(response["Result"].SerializedFilterSettings);
                    }
                }))
                // .pipe(map((response: SharedReport) => {
                //     return JSON.parse(response.serializedFilterSettings);
                // }))
                .pipe(catchError(err => this.handleServerApiError(err)));
        } catch (e) {
            this.handleUnexpectedApiError(e);
            return throwError(() => new Error(e.Message));
        }
    }


    saveFilterSettings(serializedSettings: any): Observable<SharedReport> {
        try {
            const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
            return this.http.post(this.baseUrl + "SaveFilterSettings", serializedSettings, {headers: headers})
                .pipe(
                    map((response) => {
                        let sharedReportEntry: SharedReport;
                        if (response["result"]) {
                          sharedReportEntry = response["result"];
                        } else if (response["Result"]) { //Stöd för Result med stora bokstäver... (innan .net6)
                          sharedReportEntry = {
                            id: response["Result"].Id,
                            serializedFilterSettings: response["Result"].SerializedFilterSettings,
                            created: response["Result"].Created
                          };
                        }
                        return sharedReportEntry;
                    }),
                    catchError(err => {
                        if (err != null)
                            this.handleServerApiError(err);
                        else
                            this.handleServerApiError("Undefined error");
                        return of(null);
                    })
                );
        } catch (e) {
            this.handleUnexpectedApiError(e);
            return throwError(() => new Error(e.Message));
        }
    }

}
